import type * as React from 'react';

function SvgLegal(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg height="1em" viewBox="0 0 20 20" width="1em" {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="M20 10c0 5.522-4.477 10-10 10S0 15.522 0 10C0 4.477 4.477 0 10 0s10 4.477 10 10" fill="#1ED560" />
        <path
          d="M7.104 12.204v-.673H4.917l1.017-1.238c.625-.764.625-.764.818-1.093.224-.374.328-.734.328-1.124 0-.901-.561-1.406-1.562-1.406-1.01 0-1.611.497-1.683 1.399l.785.061c.104-.52.401-.787.866-.787.488 0 .745.244.745.703 0 .466-.265 1.001-.85 1.704l-1.586 1.919v.535h3.309zm3.43 0V6.746h-.577l-1.499.612.265.627.953-.39v4.609h.858zm4.215-.978v-1.46h1.498v-.627h-1.498V7.671h-.714v1.468h-1.498v.627h1.498v1.46h.714z"
          fill="#00182E"
        />
      </g>
    </svg>
  );
}

export default SvgLegal;
